// src/pages/Home.jsx
import React from 'react';
import { Box, Container, Typography, Button, Toolbar, Paper, Grid } from '@mui/material';
import Subject from './Subject';
import Activities from './Activities';
import MoreActivities from './MoreActivities';
import Footer from './Footer';
import Header from '../components/Header';
import VideoSection from './VideoSection';

function Home() {
    return (
        <>
            <Header />
            <Container sx={{ py: 4 }}>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center' }}>

                    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2, position: 'relative' }}>
                        {/* Monitor Image */}
                        <img
                            src="/image/combined.gif"
                            alt="Monitor"
                            style={{
                                width: '90%',
                                borderRadius: '8px',
                                zIndex: 1
                            }}
                        />

                        <img
                            src="/image/Teacherfull.png"
                            alt="Image 04"
                            style={{
                                position: 'absolute',
                                bottom: '50%',
                                left: '-100px',
                                transform: 'translateY(50%)',
                                width: '50%',
                                zIndex: 99
                            }}
                        />



                    </Box>


                    {/* Left Section */}
                    <Box id='title' sx={{ flex: 1, textAlign: { xs: 'center', md: 'center' }, p: 2 }}>
                        <Typography variant="h3" component="div" className="gradient-text">
                            Actify365
                        </Typography>
                        <Typography variant="h3" component="div" className="bold gradient-text">
                            The Real Learning
                        </Typography>
                        <Typography variant="h3" component="div" className="gradient-text">
                            Starts Here
                        </Typography>
                        {/* <Typography variant="subtitle1" color="textSecondary" id="sub-title" sx={{ mt: 2 }}>
                            Learn anywhere. Cancel anytime.
                        </Typography> */}
                        <Button
                            href="https://demo.actify365.com/"
                            target="_blank"
                            variant="contained"
                            color="primary"
                            size="medium"
                            sx={{ mt: 3, borderRadius: '50px', fontWeight: '600', fontSize: '20px', color: '#fff' }}
                            className='cta-button'
                        >
                            LAUNCH COURSE
                        </Button>

                    </Box>
                </Box>

            </Container>
            {/* menu Section */}



            <Box
                id="menu"
                sx={{
                    overflowX: 'hidden', // Hide the scrollbar by default
                    whiteSpace: 'nowrap',
                    paddingTop: '20px',

                }}
            >
                <Toolbar
                    sx={{
                        justifyContent: 'flex-start',
                        display: 'inline-flex',
                        padding: '10px',
                        marginLeft: '10px',
                    }}
                >
                    {['English', 'Hindi', 'Math', 'Computer', 'EVS', 'Science', 'Art & Crafts', 'GK', 'Yoga', 'Role-play', 'Story', 'Poem'].map((item, index) => (
                        <Typography
                            key={index}
                            variant="h6"
                            component="div"
                            sx={{
                                margin: '0 20px',
                                color: '#fff',
                                display: 'inline-block',
                            }}
                        >
                            ⦁ {item}
                        </Typography>
                    ))}
                </Toolbar>
            </Box>




            <section>
                <Container maxWidth="lg">
                    {/* Learn More Section */}
                    <Box id="learn-more-section" sx={{ mb: 4 }}>
                        <Grid item>
                            {/* <img
                            id="superheros"
                            width="100%"  // Make the image responsive by setting width to 100%
                            height="auto" // Ensure height is proportional to width
                            src="/img/superheros_v1.webp"
                            alt="3 superheros"
                            style={{ maxWidth: '100%', height: 'auto' }} // Ensure it does not overflow the container
                        /> */}
                        </Grid>
                        <Grid item>
                            <Box id="learn-more-titles">
                                <Typography className="learn-more-title" sx={{ lineHeight: 1 }} gutterBottom>
                                    Learn More
                                </Typography>
                                <Typography id="about-abc" sx={{ lineHeight: 1 }} className="learn-more-title">
                                    About Actify365!
                                </Typography>
                            </Box>
                        </Grid>
                    </Box>

                    {/* Learning Path Section */}
                    <Box id="learning-path-section" sx={{ mb: 4 }}>

                        <VideoSection />


                    </Box>

                    {/* Testimonials Section */}

                    {/* Step by Step */}
                    <Box id="learning-path-section" sx={{ paddingY: 6, }}>
                        <Grid container spacing={4} alignItems="center">
                            {/* Left Section */}
                            <Grid item xs={12} md={6}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        textAlign: "center",
                                        paddingX: 3,
                                    }}
                                >
                                    {/* <Box
                                        component="img"
                                        id="learning-path-icon"
                                        src="/img/star_dotted_icon_v1.svg"
                                        alt="Star Icon representing the learning path"
                                        sx={{
                                            width: { xs: "60%", md: "40%" },
                                            height: 40,
                                            marginTop: -5,
                                            marginBottom: 2,
                                        }}
                                    /> */}
                                    <Typography component="h2" variant="h4" sx={{ fontWeight: "bold" }}>
                                        Step-by-Step
                                    </Typography>
                                    <Typography component="h2" variant="h4" sx={{ fontWeight: "bold", lineHeight: 1 }}>
                                        Learning Path
                                    </Typography>
                                </Box>
                            </Grid>

                            {/* Right Section */}
                            <Grid item xs={12} md={6}>
                                <Box sx={{ paddingX: { xs: 3, md: 0 } }}>
                                    <Typography
                                        id="learning-path-description"
                                        variant="body1"
                                        sx={{
                                            color: "text.secondary",
                                            maxWidth: "600px",
                                            fontSize: "1rem",
                                            lineHeight: 1.6,
                                            textAlign: "justify",
                                        }}
                                    >
                                        Empower your child’s education with the <strong>ACTIFY365 Step-by-Step Learning Path!</strong> With over 1,000 captivating lessons spread across six levels, this curriculum ensures steady progress while keeping learning exciting and motivating every step of the way.
                                    </Typography>

                                    {/* Optional Call-to-Action Button */}

                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box
                        id="learning-path-icon-container"
                        sx={{
                            display: "flex",
                            justifyContent: "center", // Centers horizontally
                            alignItems: "center",     // Centers vertically
                            width: "100%",
                            marginBottom: 2, // Space between image and text
                        }}
                    >
                        <img
                            id="learning-path-icon"
                            src="/image/Journey.jpg"
                            alt="Learning Path Icon"
                            style={{
                                maxWidth: "80%", // Restrict image width to 60% of the container
                                height: "auto",  // Maintain aspect ratio
                            }}
                        />
                    </Box>


                    <Box
                        sx={{
                            backgroundColor: "#fff", // Light blue background
                            paddingY: 6,
                            paddingX: { xs: 2, md: 6 },
                        }}
                    >
                        <Grid container spacing={4} alignItems="center">
                            {/* Left Section: Testimonial 1 */}
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <Box sx={{ textAlign: "center", paddingX: 2 }}>
                                    <Box component="img" src="img/blue_quotes_v1.svg" alt="Quotes" sx={{ width: 20, marginBottom: 2 }} />

                                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333", marginBottom: 2 }}>
                                        ACTIFY365 is a Game-Changer!
                                    </Typography>

                                    <Typography variant="body1" sx={{ color: "#555", marginBottom: 2, lineHeight: 1.6 }}>
                                        "My children are thrilled to learn and never want to stop! Actify365 has made this educational journey full of fun for kids. Activities like Listening and Speaking are much-awaited features for beginners. Thank you for making learning so enjoyable and effective."
                                    </Typography>

                                    <Typography variant="body2" sx={{ color: "#0078ff", fontStyle: "italic", marginTop: 2 }}>
                                        — Proud Mother of a UKG Student
                                    </Typography>
                                </Box>
                            </Grid>

                            {/* Right Section: Testimonial 2 */}
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <Box sx={{ textAlign: "center", paddingX: 2 }}>
                                    <Box component="img" src="img/blue_quotes_v1.svg" alt="Quotes" sx={{ width: 20, marginBottom: 2 }} />

                                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333", marginBottom: 2 }}>
                                        ACTIFY365 is a Hit in Our Home!
                                    </Typography>

                                    <Typography variant="body1" sx={{ color: "#555", marginBottom: 2, lineHeight: 1.6 }}>
                                        "Our kid loves ACTIFY365! The platform offers various engaging learning activities that keep him excited and motivated."
                                    </Typography>

                                    <Typography variant="body2" sx={{ color: "#0078ff", fontStyle: "italic", marginTop: 2 }}>
                                        — Proud Teacher of a School
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                </Container>

            </section>
            <Box
                id="home-divider-lg"
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: "center",
                    gap: 3,
                    padding: 3,
                    backgroundColor: "#009b13",
                }}
            >
                {/* Image Section */}
                <Grid item xs={12} md={6}>
                    <Box
                        component="img"
                        src="/image/Greenbanner.jpg"
                        alt="Mom's Choice Time"
                        sx={{
                            width: "100%",
                            maxWidth: "500px",
                            height: "auto",
                             
                        }}
                    />
                </Grid>

              
            </Box>
            <Subject />
            <Activities />
            <MoreActivities />
            <Footer />
        </>
    );
}

export default Home;
